import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../App';

export default function OnboardingWizard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get('/api/onboarding/status')
      .then(res => { setData(res.data); setDismissed(res.data.dismissed); })
      .catch(() => setDismissed(true))
      .finally(() => setLoading(false));
  }, []);

  const handleDismiss = async () => {
    setDismissed(true);
    try { await api.post('/api/onboarding/dismiss'); } catch {}
  };

  if (loading || dismissed || !data || data.all_complete) return null;

  const gradients = {
    'fa-user-check': 'from-emerald-500 to-green-600',
    'fa-user-plus': 'from-blue-500 to-indigo-600',
    'fa-tower-broadcast': 'from-orange-500 to-red-500',
    'fa-brain': 'from-purple-500 to-violet-600',
    'fa-file-invoice': 'from-pink-500 to-rose-500',
    'fa-robot': 'from-teal-500 to-cyan-600',
  };

  return (
    <div className="card-interactive p-6 mb-6 relative overflow-hidden animate-slide-up" data-testid="onboarding-wizard">
      <div className="absolute top-0 left-0 w-full h-1 bg-surface-alt">
        <div className="h-full bg-gradient-to-r from-primary to-emerald-500 transition-all duration-700" style={{ width: `${data.progress_pct}%` }} />
      </div>

      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading text-lg font-bold text-text-primary">Getting Started</h3>
          <p className="text-sm text-text-muted mt-0.5">{data.completed} of {data.total} steps completed</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm font-bold text-primary tabular-nums">{data.progress_pct}%</span>
          <button onClick={handleDismiss} className="text-text-muted hover:text-text-primary transition-colors p-1" data-testid="dismiss-onboarding">
            <i className="fa-solid fa-xmark text-sm" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {data.steps.map((step, i) => (
          <div key={step.id} className="relative" data-testid={`onboarding-step-${step.id}`}>
            {step.action_path && !step.completed ? (
              <Link to={step.action_path} className="block p-3 rounded-xl border border-border hover:border-primary/30 hover:shadow-card bg-surface-alt transition-all group">
                <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${gradients[step.icon] || 'from-gray-400 to-gray-500'} flex items-center justify-center mb-2 group-hover:scale-110 transition-transform ${step.completed ? 'opacity-50' : ''}`}>
                  {step.completed ? <i className="fa-solid fa-check text-white text-sm" /> : <i className={`fa-solid ${step.icon} text-white text-sm`} />}
                </div>
                <p className={`text-xs font-medium ${step.completed ? 'text-text-muted line-through' : 'text-text-primary'}`}>{step.title}</p>
              </Link>
            ) : (
              <div className={`p-3 rounded-xl border ${step.completed ? 'border-primary/20 bg-primary/5' : 'border-border bg-surface-alt'}`}>
                <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${gradients[step.icon] || 'from-gray-400 to-gray-500'} flex items-center justify-center mb-2 ${step.completed ? 'opacity-80' : 'opacity-50'}`}>
                  {step.completed ? <i className="fa-solid fa-check text-white text-sm" /> : <i className={`fa-solid ${step.icon} text-white text-sm`} />}
                </div>
                <p className={`text-xs font-medium ${step.completed ? 'text-primary' : 'text-text-muted'}`}>{step.title}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
